export default "__VITE_ASSET__Dp50UM3w__"